import React from 'react';
import { Route, Routes } from 'react-router-dom';
import BasicForm from '../../../Form/ReduxForm/BasicForm/index';
import CheckFormControls from '../../../Form/ReduxForm/CheckFormControls/index';
import FileUpload from '../../../Form/ReduxForm/FileUpload/index';
import FloatingLabelsForm from '../../../Form/ReduxForm/FloatingLabelsForm/index';
import FormDropzone from '../../../Form/ReduxForm/FormDropzone/index';
import FormLayouts from '../../../Form/ReduxForm/FormLayouts/index';
import FormPicker from '../../../Form/ReduxForm/FormPicker/index';
import FormValidation from '../../../Form/ReduxForm/FormValidation/index';
import MaskForm from '../../../Form/ReduxForm/MaskForm/index';
import MaterialForm from '../../../Form/ReduxForm/MaterialForm/index';
import WizardForm from '../../../Form/ReduxForm/WizardForm/index';
import BasicHookForm from '../../../Form/ReactHookForm/BasikHookForm';
import FormHookValidation from '../../../Form/ReactHookForm/FormHookValidation';
import FormHookWizard from '../../../Form/ReactHookForm/WizardForm';

export default () => (
  <Routes>
    <Route path="/forms/redux_form/basic_form" element={<BasicForm />} />
    <Route path="/forms/redux_form/check_form_controls" element={<CheckFormControls />} />
    <Route path="/forms/redux_form/file_upload" element={<FileUpload />} />
    <Route path="/forms/redux_form/floating_labels_form" element={<FloatingLabelsForm />} />
    <Route path="/forms/redux_form/form_dropzone" element={<FormDropzone />} />
    <Route path="/forms/redux_form/form_layouts" element={<FormLayouts />} />
    <Route path="/forms/redux_form/form_picker" element={<FormPicker />} />
    <Route path="/forms/redux_form/form_validation" element={<FormValidation />} />
    <Route path="/forms/redux_form/mask_form" element={<MaskForm />} />
    <Route path="/forms/redux_form/material_form" element={<MaterialForm />} />
    <Route path="/forms/redux_form/wizard_form" element={<WizardForm />} />
    <Route path="/forms/react_hook_form/basic_form" element={<BasicHookForm />} />
    <Route path="/forms/react_hook_form/form_validation" element={<FormHookValidation />} />
    <Route path="/forms/react_hook_form/wizard_form" element={<FormHookWizard />} />
  </Routes>
);
